<template>
  <v-app>
    <div class="view-main">
      <div class="smp ma-1">
        <div
            v-if="!isPremium"
        >
          <AdSmp/>
        </div>
        <SaveLayoutSmp
            :auto-save="autoSave"
            :last-save-time="lastSaveTime"
            :save="callSave"
            :saving="saving"
            style="width:100%;"
            @change="autoSave=$event"
        />
      </div>

      <div class="sm-hide pb-4 px-3 mt-4 mx-4">
        <v-layout
            v-if="!hideAppbar"
            :style="`height: 60px;background-color: ${backgroundColor}`"
            align-center
            class="ma-0 pa-0"
            d-flex
            justify-start
        >
          <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
          />
          <v-btn
              color="secondary"
              elevation="0"
              height="30px"
              icon
              @click="openFolder()"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div style="font-weight: bold;font-size: 18px;">
            本文編集
          </div>
        </v-layout>
      </div>
      <v-text-field
          ref="titleelement"
          v-model="inputTitle"
          :background-color="backgroundColor"
          :maxlength="inputLength.title"
          :style="{fontSize:fontSize*1.1+'px',borderRadius:'0px'}"
          class="grey-text  ma-0 pa-0 mt-0 mx-sm-7 mx-2 mb-0 hide-details"
          dense
          flat
          label="本文タイトルを入力する"
          single-line
          solo
      />
      <EditorMenu
          :execute-input="executeInput"
          :on-click-back="onClickBack"
          :on-click-next="onClickNext"
          :oneline="oneline"
          :site-type="siteType"
          :text-area="textArea"
          :input-text="inputText"
          :scroll-width="horizontalWidth"
          class="mx-sm-7 mx-2 mb-1 mt-3"
      />
      <div
          class="ma-0 mx-sm-7 mx-0 px-2 py-1"
          style="max-width:100%;border-radius: 4px;background-color: var(--v-secondary-base);color:white;font-size:11px;display:inline;"
      >
        左から順に、Ctrl＋1～9の数字でクイックメニュー入力できます
      </div>
      <div style="height:100%;">
        <v-textarea
            ref="textarea"
            v-model="inputText"
            :background-color="backgroundColor"
            color="text"
            :class="' mx-sm-7 mx-2 mt-3 grey-text linespace'+lineSpaceSize"
            :height="editorHeight"
            :maxlength="inputLength.description"
            :style="{fontSize:fontSize+'px',borderRadius:'0px;'}"
            counter
            dense
            flat
            label="本文テキストを入力する"
            name="input-7-4"
            no-resize
            solo
            @keydown.enter="enter"
        />
      </div>
    </div>
    <div
        :class="`view-right-menu pc ${hideAppbar ? '':'smallarea'}`"
    >

      <SaveLayoutPc
          :auto-save="autoSave"
          :last-save-time="lastSaveTime"
          :save="callSave"
          :saving="saving"
          @change="autoSave=$event"
      />
      <div style="height: 100%;">
        <MiniDocumentArea
            v-if="isPremium"
            :input-text="inputText"
            :site-type="siteType"
            :input-title="inputTitle"
            :apply-history="applyHistory"
        />
        <div
            v-else
        >
          <AdPc/>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import config from "@/const";
import dayjs from "dayjs";
import SaveLayoutPc from '../component/SaveLayoutPc.vue';
import SaveLayoutSmp from '../component/SaveLayoutSmp.vue';
import MiniDocumentArea from '../component/MiniDocumentArea.vue';
import EditorMenu from '../component/EditorMenu.vue';
import firebase from "firebase/app";
import axios from "axios";
import AdPc from "@/component/AdPc";
import AdSmp from "@/component/AdSmp";

export default {
  name: "NovelEdit",
  components: {
    AdSmp,
    AdPc,
    SaveLayoutPc,
    SaveLayoutSmp,
    MiniDocumentArea,
    EditorMenu,

  },
  data() {
    return {
      fullheight: window.innerHeight,
      inputLength: config.INPUT_LENGTH.text,
      inputText: "",
      inputTitle: "",
      textArea: null,
      siteType: null,
      accentColor: null,
      backgroundColor: null,
      autoSave: null,
      lastSaveTime: null,
      saving: false,
      saver: null,
      editItem: null,
      horizontalWidth: 0
    }
  },
  computed: {
    ...mapState({
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.value,
      autoSpace: state => state.userModule.user.autoSpace,
      questionAfterSpace: state => state.userModule.user.questionAfterSpace,
      threePointReaderRule: state => state.userModule.user.threePointReaderRule,
      oneline: state => state.userModule.user.oneline,
      isPremium: state => state.userModule.isPremium,
      hideAppbar: state => state.userModule.hideTopBottomMode
    }),
    editorHeight() {
      if (window.innerWidth<960) {
        if(window.innerWidth < 520){
          return this.fullheight - 400
        }else{
          return this.fullheight - 460
        }

      } else {
        if (this.hideAppbar) {
          return this.fullheight - 210
        } else {
          return this.fullheight - 460
        }
      }

    }
  },
  watch: {
    $route: {
      async handler() {
        const novel = this.$store.state.NovelListModule.NovelList.find(item => item.id == config.HASH_IDS.decode(this.$route.params.novelid)[0])
        if (novel == null) {
          this.$router.push({name: 'Novels'})
        } else {
          this.siteType = config.findSiteType(novel.targetSite);
          if (this.$route.params.text_id != "create") {
            const user = firebase.auth().currentUser
            const token = await user.getIdToken(false)
            if (token == null) {
              return
            }
            // console.log("token="+token)
            try {
              const ret = await axios.get(config.API_URL + "auth/page", {
                headers: {"X-Firebase-Auth": token},
                params: {
                  "id": config.HASH_IDS.decode(this.$route.params.text_id)[0]
                },
                data: {}
              })
              if (!ret.data) {
                this.$router.push({
                  name: 'NovelIndex',
                  params: {novelid: this.$route.params.novelid}
                })
              } else {
                this.editItem = ret.data
                this.inputTitle = ret.data.name
                this.inputText = ret.data.content
              }
            } catch (e) {
              this.$router.push({
                name: 'NovelIndex',
                params: {novelid: this.$route.params.novelid}
              })
            }
          }
        }
      }, immediate: true
    },
    inputText: {
      handler: function (val, oldVal) {
        this.setAutoSave()
      },
    },
    inputTitle: {
      handler: function (val, oldVal) {
        this.setAutoSave()
      },
    },
    autoSave(newName) {
      localStorage.autoSave = newName;
      if (localStorage.autoSave && this.hasDiff()) {
        this.callSave()
      }
    },
    async saver() {
      if (this.saver != null) {
        this.saveTimer = null
        const l = this.saver
        this[l] = !this[l]

        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        if (token == null) {
          return
        }
        let saveData = this.editItem
        if (saveData == null) {
          saveData = {
            createdDate: Date.now(),
            novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
            folderId: this.$route.query.folderid ? config.HASH_IDS.decode(this.$route.query.folderid)[0] : -1
          }
        }
        console.log("saveStart")

        saveData.modifiedTimestamp = Date.now()
        saveData.updateDate = Date.now()
        saveData.name = this.inputTitle
        saveData.content = this.inputText
        axios.post(config.API_URL + "auth/page", saveData, {
          headers: {"X-Firebase-Auth": token, "fromWeb": true},
        }).then(value => {
          this.lastSaveTime = Date.now()
          this.editItem = value.data;
          history.replaceState('', '', config.HASH_IDS.encode(this.editItem.id));
          this[l] = false
          this.saver = null
          console.log("save end")
        }).catch(reason => {
          alert("保存中にエラーが発生しました。もう一度保存してください")
          this[l] = false
          this.saver = null
        });
      }
    }
  },
  mounted() {
    this.textArea = this.$refs.textarea.$refs.input;
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
    if (localStorage.autoSave != null && localStorage.autoSave != undefined) {
      this.autoSave = localStorage.autoSave == "true";
    } else {
      this.autoSave = true;
    }
    // 要素の幅を取得するメソッド
    this.getTargetWidth()
    // ユーザーがウィンドウサイズを変更したら実行されるようにする
    window.addEventListener('resize', this.getTargetWidth)
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  created() {
    window.addEventListener("beforeunload", this.leaveHandler)
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.leaveHandler)
    window.removeEventListener('resize', this.getTargetWidth);
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasDiff()) {
      // アラートダイアログを表示して、結果に応じて遷移
      const msg = "編集した内容が保存されていません。遷移しますか？";
      const answer = window.confirm(msg);
      next(answer);
    } else {
      // next()は必ず呼び出さないといけない
      next();
    }
  },
  methods: {
    getTargetWidth() {
      this.horizontalWidth = this.$refs.titleelement.$el.clientWidth
    },
    leaveHandler(event) {
      // 入力と保存に差分があったらブラウザのダイアログ
      if (this.hasDiff()) {
        event.preventDefault();
        event.returnValue = "編集した内容が保存されていません。遷移しますか？";
      }
    },
    callSave() {
      this.saver = 'saving'
    },
    /**
     * 戻る
     */
    onClickBack() {
      document.execCommand("undo")
    },
    /**
     * 進む
     */
    onClickNext() {
      document.execCommand("redo")
    },
    applyHistory(item){
      this.inputText = item.content
      this.inputTitle=item.name
    },
    /**
     * TextAreaへの入力とカーソル移動
     * @param text
     * @param selectionStart
     * @param selectionEnd
     */
    executeInput(text, selectionStart, selectionEnd) {
      this.textArea.focus();
      document.execCommand('insertText', false, text);
      this.$nextTick().then(() => {
        this.textArea.selectionStart = selectionStart;
        this.textArea.selectionEnd = selectionEnd;
        this.textArea.focus();
      });
    },

    /**
     * 本文のEnterキーを押下したタイミングで発火
     * @param event
     */
    enter(event) {
      setTimeout(() => {

        let cacheSelection = this.textArea.selectionStart;
        const cacheInputTextLength = this.inputText.length


        if (this.autoSpace) {
          this.inputText = this.inputText.replace(/^([^　「『（]*?)$/gm, '　$1');
          // 鉤括弧が入ると先頭のスペースが消える
          this.inputText = this.inputText.replace(/\n　「/g, "\n「");
          this.inputText = this.inputText.replace(/\n　（/g, "\n（");
          this.inputText = this.inputText.replace(/\n　『/g, "\n『");
        }

        // ？と！の後ろにスペース入れる対応
        // Enterのタイミングで行わないと変換周りが気持ち悪くなってしまう
        if (this.questionAfterSpace) {
          // this.inputText = this.inputText.replace(/([！？])([^！？　]+)$/gm, '$1　$2');
          if(this.inputText.match(/([！？])([^！？　」』）\\)\n]+)/gm))
          this.inputText = this.inputText.replace(/([！？])([^！？　」』\\)）\n]+)/gm, '$1　$2');
        }

        if (this.threePointReaderRule) {
          // …2連続対応
          this.inputText = this.inputText.replace(/([^…])([…])([^…])/g, '$1$2…$3');
          // ―2連続対応
          this.inputText = this.inputText.replace(/([^―])([―])([^―])/g, '$1$2―$3');
        }
        if (this.inputText.length != cacheInputTextLength) {
          cacheSelection += this.inputText.length - cacheInputTextLength;
          this.$nextTick(() => {
            this.textArea.selectionStart = cacheSelection;
            this.textArea.selectionEnd = cacheSelection;
            this.textArea.focus();
          });
        }

      }, 200);
    },
    hasDiff() {
      if (!this.editItem) {
        if (this.inputText || this.inputTitle) {
          return true
        } else {
          return false
        }
      } else {
        if (this.inputText != this.editItem.content) {
          return true
        }
        if (this.inputTitle != this.editItem.name) {
          return true
        }
      }
      return false
    },
    setAutoSave() {
      if (this.autoSave) {
        if (this.hasDiff()) {
          if (this.saveTimer != null) {
            clearTimeout(this.saveTimer)
          }
          this.saveTimer = setTimeout(this.callSave, config.AUTO_SAVE_TIME)
        }
      }
    },
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    openFolder(){
      if(this.editItem.folderId && this.editItem.folderId!=-1){
        this.$router.push({
          name: 'NovelIndexInFolder',
          params: {novelid: this.$route.params.novelid,folderid:this.encodeHash(this.editItem.folderId)}
        })
      }else{
        this.$router.push({
          name: 'NovelIndex',
          params: {novelid: this.$route.params.novelid}
        })
      }

    }
  },

}
</script>

<style scoped>
.flex-container {
  display: flex;
  height: 100%;
}

textarea {
  overflow-anchor: none;
}


</style>
